import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import ConfirmCancel from "../../../components/DialogComponent/ConfirmCancel";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import CreateShift from "./CreateShift";
import { getShiftsList } from "../../../services/apiservices/shifts";
import {  ArrowRight } from "lucide-react";
import { deleteClientShift } from "../../../services/apiservices/client";
import { useParams } from "react-router";
import styles from "../clients.module.scss";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Button } from "../../../components/ui/button";
import { useMediaQuery } from "@mui/material";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";

const stepId = 3;
function Step3(props) {
  const {shiftsList, setShiftsList, stepError, setStepError, setPosFrequency, posFrequency, settingsData} = props;
  // const [stepError, setStepError] = useState({});
  // const [shiftsList, setShiftsList] = useState([]);
  const [allShifts, setAllShifts] = React.useState([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [updatedShift, setUpdatedShift] = useState(false);
  // const [showDuplicateDialog, setShowDuplicateDialog] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const { clientId } = useParams();
  let history = useNavigate();
  const {
    currentStep,
    goToStep,
    onCancelAll,
    stepContentValues,
    loading,
    classes,
  } = props;

  const taskBehaviorOptions = [
    {
      value: "none",
      label: "None (0%)",
      frequency: 0,
    },
    {
      value: "low",
      label: "Low (5%)",
      description: "Employees will be randomly prompted for photos on ~1 in 20 visits (5% frequency).",
      frequency: 5,
    },
    {
      value: "medium",
      label: "Medium (10%)",
      description: "Employees will be randomly prompted for photos on ~1 in 10 visits (10% frequency).",
      frequency: 10,
    },
    {
      value: "high",
      label: "High (20%)",
      description: "Employees will be randomly prompted for photos on ~1 in 5 visits (20% frequency).",
      frequency: 20,
    },
  ];

  const callfetchShifts = () => {
    getShiftsList(
      {},
      (res) => {
        if (res) {
          setAllShifts(res);
        }
      },
      (resError) => {
        console.log("resError", resError);
      }
    );
  };
  useEffect(() => {
    callfetchShifts();
  }, []);

  const setEditData = (editData) => {
    if (editData?.shiftData) {
      let shfitdata = [...Object.keys(editData?.shiftData)].map((shiftId) => {
        let inShiftData = editData?.shiftData[shiftId];
        let inShiftDataKeys = Object.keys(inShiftData);
        let shiftItemData = inShiftData[inShiftDataKeys[0]];
        return {
          shiftId: shiftId,
          title: shiftItemData?.title,
          titlen: shiftItemData?.titlen,
          day: shiftItemData?.day,
          status: true,
          startTime: shiftItemData?.timeRange?.startTime,
          endTime: shiftItemData?.timeRange?.endTime,
          startDate: shiftItemData?.timeRange?.startDate,
          endDate: shiftItemData?.timeRange?.endDate,
          opentasksstatus: shiftItemData?.timeRange?.opentasksstatus,
        };
      });

      setShiftsList(shfitdata);
    } else if (editData?.shiftsList) {
      let shfitdata = Array.isArray(editData?.shiftsList)
        ? editData.shiftsList?.map((inShiftData) => ({
          shiftId: inShiftData?.shiftId,
          title: inShiftData?.title,
          titlen: inShiftData?.titlen,
          day: inShiftData?.day,
          status: true,
          startTime: inShiftData?.startTime,
          endTime: inShiftData?.endTime,
          startDate: inShiftData?.startDate,
          endDate: inShiftData?.endDate,
          opentasksstatus: inShiftData?.opentasksstatus,
        }))
        : Object.keys(editData?.shiftsList || {})?.map((shiftId) => {
          const inShiftData = editData?.shiftsList[shiftId];
          return {
            shiftId,
            title: inShiftData?.title,
            titlen: inShiftData?.titlen,
            day: inShiftData?.day,
            status: true,
            startTime: inShiftData?.timeRange?.startTime,
            endTime: inShiftData?.timeRange?.endTime,
            startDate: inShiftData?.timeRange?.startDate,
            endDate: inShiftData?.timeRange?.endDate,
            opentasksstatus: inShiftData?.timeRange?.opentasksstatus,
          };
        });

      setShiftsList(shfitdata);
    }
  };

  useEffect(() => {
    if (props?.editData !== false) {
      setEditData(props?.editData);
    }
  }, [props?.editData]);

  useEffect(() => {
    if (props?.displayStep == 3 && stepContentValues && props?.editData === false) {
      setEditData(stepContentValues);
    }
  }, [props?.displayStep]);

  const checkShiftChanges = (shiftsList, newShiftData) => {
    if (shiftsList.length !== newShiftData.length) return true;

    for (const newShift of newShiftData) {
      const oldShift = shiftsList?.find(s => s.shiftId === newShift?.shiftId);
      if (!oldShift) return true;

      if (oldShift?.title !== newShift?.title) {
        return true;
      }
    }
    return false;
  };

  const onCreateShift = (shiftData) => {
    // const isDuplicate = shiftsList?.some(
    //  (shift) => shift?.title?.trim()?.toLowerCase() === shiftData?.title?.trim()?.toLowerCase()
    // );

    // if (isDuplicate) {
    //   setShowDuplicateDialog(true);
    //   return;
    // }

    const baseTitle = shiftData?.title?.trim();
    if (!baseTitle) return;

    let nextIndex = 0;

    for (const shift of shiftsList) {
      const title = shift?.title?.trim()?.toLowerCase();
      if (title === baseTitle.toLowerCase()) {
        nextIndex = Math.max(nextIndex, 1);
      } else if (title?.startsWith(`${baseTitle.toLowerCase()} -`)) {
        const num = parseInt(title.split(" - ")[1]);
        if (!isNaN(num)) {
          nextIndex = Math.max(nextIndex, num + 1);
        }
      }
    }

    const updatedTitle =
      nextIndex === 0 ? baseTitle : `${baseTitle} - ${nextIndex}`;

    const newShiftData = {
      ...shiftData,
      title: updatedTitle,
    };

    let sendShiftData = [...shiftsList, newShiftData];
    const updatedShift = checkShiftChanges(shiftsList, sendShiftData);
    setUpdatedShift(updatedShift);
    setShiftsList(sendShiftData);
    resetError();
  };

  const onUpdateShift = (shiftId, shiftData) => {
    if (shiftId && shiftsList?.some((sitem) => sitem.shiftId === shiftId)) {
      let sendShiftData = [
        ...shiftsList?.map((sitem) =>
          sitem.shiftId === shiftId ? shiftData : sitem
        ),
      ];
      const updatedShift = checkShiftChanges(shiftsList, sendShiftData);
      setUpdatedShift(updatedShift);
      setShiftsList(sendShiftData);
    } else {
      let sendShiftData = [...shiftsList, shiftData];
      const updatedShift = checkShiftChanges(shiftsList, sendShiftData);
      setUpdatedShift(updatedShift);
      setShiftsList(sendShiftData);
    }
  };

  const getTasktl = (shiftItem) => {
    let shiftid = shiftItem.shiftId;
    let shiftidcon = props?.editData;
    let shifttt = shiftidcon?.shiftData[shiftid];

    let inShiftDataKeyss = Object.keys(shifttt);

    const ttt = inShiftDataKeyss.map((taaskt) => {
      return shifttt[taaskt].tasksList.length;
    });
    var total = 0;
    for (var i in ttt) {
      total += ttt[i];
    }
    return total;
  };
  const onDeleteShiftData = async (index, shiftItem) => {
    let sendShiftData = [
      ...shiftsList.filter((sitem) => sitem.shiftId !== shiftItem.shiftId),
    ];

    deleteClientShift(clientId, shiftItem).then(() => {
      if (clientId && clientId !== undefined) {
        history({
          pathname: `/peoples/createClient/${clientId}`,
          state: {
            stepid: "3",
          },
        });
        window.location.reload();
      } else {
        history({
          pathname: `/peoples/createClient`,
          state: {
            stepid: "3",
          },
        });
        window.location.reload();
      }
    });
    setShiftsList(sendShiftData);
  };

  const handleShiftCheckChange = (event, shiftId) => {
    const {
      target: { checked },
    } = event;
    let newShiftListData = [
      ...shiftsList.map((shiftListItem) => {
        return shiftId === shiftListItem?.shiftId
          ? { ...shiftListItem, status: checked }
          : shiftListItem;
      }),
    ];

    setShiftsList(newShiftListData);
  };

  const resetError = () => {
    setStepError({});
  };

  const validateAndGoNext = () => {
    let errormessages = stepError;
    let isValid = true;
    if (
      typeof shiftsList === "undefined" ||
      shiftsList === "" ||
      shiftsList?.length <= 0
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        shiftsList: "Must Create at least one Shift",
      };
    } else {
      errormessages = { ...errormessages, shiftsList: "" };
    }
    setStepError(errormessages);
    setUpdatedShift(false);
    if (isValid)
      props?.validateAndGoNext &&
        props?.validateAndGoNext({ shiftsList: shiftsList, posFrequency: posFrequency });
  };

  const handleCancel = () => {
    setShowDeleteDialog(false);
  };

  return (
    <>
      {!clientId && (
        <div
          style={{
            backgroundColor: "#FFF8E5",
            border: "1px solid #F1C40F",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "16px",
            marginBottom: "8px",
            fontSize: "14px",
            color: "#A75E00",
            fontWeight: 500,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>
            This client is incomplete and has been set to{" "}
            <strong>Inactive</strong> until all details are completed and saved.
          </span>
        </div>
      )}

      {updatedShift === true && (
        <div
          style={{
            backgroundColor: "#FFF8E5",
            border: "1px solid #F1C40F",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "16px",
            marginBottom: "8px",
            fontSize: "14px",
            color: "#A75E00",
            fontWeight: 500,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>
            You must click the <strong>Next</strong> button below to proceed to
            the next step.
          </span>
        </div>
      )}
    <div className="mb-24 d-flex flex-justify-end">
      <div className="flex flex-direction-column flex-end">
        <div className="d-flex flex-end gap-16">
        {settingsData?.[0]?.proofOfService === true && (
          <div>
        <div className="mb-8">
          <span className="text-sm font-semibold text-gray-800 dark:text-gray-200">
            Proof of Service Frequency
          </span>
        </div>
          <div style={{ width: isMobile ? "160px" : "220px" }}>
            <SingleSelectNew
              contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
              itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
              placeholder="Select frequency"
              value={posFrequency}
              onChange={setPosFrequency}
              options={taskBehaviorOptions}
            />
          </div>
          </div>
        )}

        <DialogComponent
          buttonWrapClassName={styles.addShiftWrapper}
          buttonClassName={styles.addShiftButton}
          buttonProps={{ size: "medium", variant: "link" }}
          buttonLabel={
            <span className={styles.addShiftContent}>
              <AddOutlinedIcon className={styles.icon} />
              Add Shift
            </span>
          }
          ModalTitle="Add New Shift"
          ModalDescription="Create a shift for this client. Choose a predefined shift type or create a custom one."
          ModalContent={
            <CreateShift
              allShifts={allShifts || []}
              shiftsList={shiftsList}
              onCreateShift={onCreateShift}
              resetError={resetError}
            />
          }
        />
      </div>
      </div>
    </div>
      <Card
        className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
      >
        <CardContent className="p-24">
          <div className="d-flex flex-direction-column mb-24">
            <h2 className={`${styles.cardProfileTitle} dark:text-white`}>
              Client Shifts
            </h2>
            <p
              className="mt-16"
              style={{
                color: "#6B7280",
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: "500",
              }}
            >
              Create unique shift(s) for your client (e.g. Morning, Evening,
              Night)
            </p>
          </div>
          {shiftsList?.length > 0 ? (
            <div className={styles.shiftGrid}>
              {shiftsList?.map((shiftItem, index) => {
                const handleDelete = () => {
                  onDeleteShiftData(index, shiftItem);
                  setShowDeleteDialog(false);
                };
                return (
                  <div
                    key={shiftItem.id}
                    className={`${styles.shiftCard} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
                  >
                    <div className={styles.shiftContent}>
                      <div className={styles.shiftHeader}>
                        <h3 className={`${styles.shiftTitle} dark:text-white`}>
                          {shiftItem?.title}
                        </h3>
                      </div>

                      <div className={styles.shiftActions}>
                        <div
                          style={{
                            border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                            borderRadius: "4px",
                            minWidth: "50%",
                          }}
                        >
                          <DialogComponent
                            buttonWrapClassName="d-inline"
                            buttonClassName={`${styles.buttons} iconbutton`}
                            buttonProps={{ size: "medium", variant: "link" }}
                            buttonLabel={
                              <span
                                className={
                                  "mt-7 w-100 d-flex flex-justify-center flex-center"
                                }
                              >
                                <EditOutlinedIcon className={styles.icon} />{" "}
                                Edit
                              </span>
                            }
                            ModalTitle={`Edit ${shiftItem?.title} Shift`}
                            ModalDescription="Create a shift for this client. Choose a predefined shift type or create a custom one."
                            ModalContent={
                              <CreateShift
                                allShifts={allShifts || []}
                                edit={shiftItem?.shiftId}
                                shiftData={shiftItem}
                                shiftsList={shiftsList}
                                onCreateShift={onUpdateShift}
                              />
                            }
                          />
                        </div>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => setShowDeleteDialog(true)}
                          className={styles.deleteButton}
                          style={{ minWidth: "50%" }}
                        >
                          <DeleteOutlineOutlinedIcon className={styles.icon} />{" "}
                          Remove
                        </Button>
                      </div>
                    </div>

                    <Dialog
                      open={showDeleteDialog}
                      onOpenChange={setShowDeleteDialog}
                    >
                      <DialogContent>
                        <DialogTitle className="mt-10">
                          Are you sure you want to delete this shift?
                        </DialogTitle>
                        <div
                          style={{
                            color: "#64748B",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          This action cannot be undone. This will permanently
                          delete the "{shiftItem.title}" shift.
                        </div>
                        <div className="d-flex flex-justify-end mv-30">
                          <Button
                            variant="outlined"
                            className="mr-20"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={handleDelete}
                            className={styles.confirmDelete}
                          >
                            Delete
                          </Button>
                        </div>
                      </DialogContent>
                    </Dialog>
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              className={`${styles.noShifts} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            >
              <h3 className={` dark:text-white ${styles.noShiftsTitle}`}>
                No shifts added
              </h3>
              <p className={styles.noShiftsText}>
                Add shifts to organize work schedules and tasks.
              </p>
              <div className={styles.noShiftsButtonWrapper}>
                <DialogComponent
                  buttonWrapClassName={styles.addShiftWrapper}
                  buttonClassName={styles.addShiftButton}
                  buttonProps={{ size: "medium", variant: "link" }}
                  buttonLabel={
                    <span className={`${styles.addShiftContent} `}>
                      <AddOutlinedIcon className={styles.icon} />
                      Add Shift
                    </span>
                  }
                  ModalTitle={`Add New Shift`}
                  ModalDescription="Create a shift for this client. Choose a predefined shift type or create a custom one."
                  ModalContent={
                    <CreateShift
                      allShifts={allShifts ? allShifts : []}
                      shiftsList={shiftsList}
                      onCreateShift={onCreateShift}
                      resetError={resetError}
                    />
                  }
                />
              </div>
              {stepError?.shiftsList && (
                <div className="mt-15 color-danger">
                  {stepError?.shiftsList}
                </div>
              )}
            </div>
          )}
        </CardContent>
      </Card>

      {updatedShift === true && (
        <div
          style={{
            backgroundColor: "#FFF8E5",
            border: "1px solid #F1C40F",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "16px",
            fontSize: "14px",
            color: "#A75E00",
            fontWeight: 500,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>
            You must click the <strong>Update</strong> button below to save your
            data.
          </span>
        </div>
      )}

      <div className="buttonsWrap d-flex flex-center flex-space-between mv-20">
        <DialogComponent
          buttonWrapClassName="d-inline"
          buttonClassName="bg-white dark:bg-gray-800"
          buttonProps={{
            variant: "outline",
            disabled: loading,
          }}
          buttonLabel={"Cancel"}
          ModalClose={true}
          ModalTitle={"Are you sure you want to cancel this entry?"}
          ModalContent={<ConfirmCancel onCancelAll={onCancelAll} />}
        />
        <Button
          color="primary"
          variant="contained"
          className={
            isMobile
              ? "ml-15 bg-green color-white"
              : "w-full sm:w-auto mr-15 bg-green color-white"
          }
          onClick={() => validateAndGoNext()}
          disabled={loading === true ? true : false}
        >
          {loading === true ? "Loading..." : "Next"}
          <ArrowRight className="ml-1 h-4 w-4" />
        </Button>
      </div>

      {/* {showDuplicateDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-2xl shadow-xl w-[90%] max-w-md p-24">
            <h2 className="text-[20px] font-semibold text-gray-800 mb-16">
              Duplicate Shift Name
            </h2>
            <p className="text-lg text-gray-600">
              A shift with the same title already exists. Please choose a different name.
            </p>

            <div className="mt-24 flex justify-end">
              <button
                onClick={() => setShowDuplicateDialog(false)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md text-sm font-medium"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
}
export default Step3;
